import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../../api/services/login-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from "@angular/material/icon";
@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

  constructor(
    private router: Router,
    private loginApiService: LoginService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
  ) {
    this.matIconRegistry.addSvgIcon(
      `welcome_icon`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../../../assets/welcome_icon.svg')
    );
  }

  ngOnInit(): void {
  }

  navigate() {
    this.router.navigate(['/registration/']);
  }

}
